import './Heading.scss';

const Heading = (props) => {
    return <div className="timeline-dot">
        <h1 id={props.id} className="the-latest">{props.children}</h1>
    </div>
}

export default Heading;
